import React, {useState, useEffect} from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ModalMushroomGrowth from "./Modal/ModalMushroomGrowth";
import {useModal} from "./ModalContext";

const images = {normal: require("../assets/logo-white.png"), scroll: require("../assets/logo-sm-light.png")};

function Header() {
    const {openModal} = useModal();

    const [isScrolled, setScrolled] = useState(false);
    const [currentImage, setCurrentImage] = useState(images.normal);
    const [imageHeight, setImageHeight] = useState(64);

    const [showModalGrowth, setShowModalGrowth] = useState(false);
    const handleCloseModalGrowth = () => setShowModalGrowth(false);
    const handleShowModalGrowth = () => setShowModalGrowth(true);

    const [isLogged, setLogged] = useState(false);

    useEffect(() => {
        global.permission().then((user) => {
            setLogged(true);
        }).catch(error => {
            console.log(error);
        });
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setCurrentImage(images.scroll);
                setImageHeight(34);
                setScrolled(true);
            } else {
                setCurrentImage(images.normal);
                setImageHeight(64);
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <Navbar expand="lg" className={"bg-transparent" + (isScrolled ? "navbar-brand-scrolled " : null)} style={{zIndex: 99}}
                    fixed="top">
                {/*<Navbar expand="lg" className="bg-dark" sticky="top">*/}
                <Container>
                    <Navbar.Brand href="/"
                                  style={{minWidth: 86, marginRight: 0, alignItems: "center", display: "flex"}}>
                        <img
                            src={currentImage}
                            height={imageHeight}
                            className="d-inline-block align-top img-header-custom"
                            alt="Geoticket logo"
                        />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link href="/blog">TRUCCHI E CONSIGLI</Nav.Link>
                            <Nav.Link href="#" onClick={handleShowModalGrowth}><span
                                style={{color: "#ED8829", fontWeight: "bold"}}>TABELLA CRESCITE</span></Nav.Link>
                            <Nav.Link href="#" onClick={() => openModal("search")}>TROVA IL TUO PERMESSO</Nav.Link>
                            <Nav.Link href="/regions">REGIONI</Nav.Link>
                            <Nav.Link href="/contact">CONTATTACI</Nav.Link>

                            {isLogged ? <Nav.Link href="/user/account">PROFILO</Nav.Link> :
                                <Nav.Link href="/login">LOGIN/REGISTRATI</Nav.Link>}
                        </Nav>
                        <Row>
                            <Col xs="auto">
                                <Button variant="success" href={"/download-app"}>Scarica l'app</Button>
                            </Col>
                        </Row>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <ModalMushroomGrowth show={showModalGrowth} onHide={handleCloseModalGrowth}/>
        </>
    );
}

export default Header;